import { type VariablesOf } from '@graphql-typed-document-node/core'
import { useMutation } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { graphql } from '~/gql'
import { useGraphQLRequest } from '~/hooks/useGraphQLRequest'
import { exists } from '~/utils'

const document = graphql(`
  mutation StrategyMemoArchiveListPage_UpdateStrategyMemoStatus(
    $strategyMemoId: ID!
    $newStatus: CustomerStrategyMemoStatusType!
  ) {
    updateCustomerStrategyMemo(id: $strategyMemoId, status: $newStatus) {
      id
    }
  }
`)
type Variables = VariablesOf<typeof document>

export const useUpdateStrategyMemoStatusMutation = (
  options: MutationOptions<void, Variables> = {},
) => {
  const graphQLRequest = useGraphQLRequest()
  const { t } = useTranslation()

  return useMutation({
    mutationFn: async (variables) => {
      const result = await graphQLRequest({ document, variables })
      const strategyMemoId = result.updateCustomerStrategyMemo?.id ?? false
      if (!exists(strategyMemoId)) {
        throw new Error(t('update_failed'))
      }
    },
    ...options,
  })
}
